import { render, staticRenderFns } from "./StartedWorkflows.vue?vue&type=template&id=559c216c"
import script from "./StartedWorkflows.vue?vue&type=script&lang=js"
export * from "./StartedWorkflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports